import React, {useEffect, useState} from 'react';
import { mostrarCarteras} from '../../redux/reducers/carterasReducers';
import AppBar from "../../components/appBar";
import Crear  from './crear';
import {Button, TableBody, TableRow, TableCell} from "@mui/material";
import PlusFab from "../../components/PlusFab";
import LoadingProgress from "../../components/LoadingProgress";
import {useLocation, useNavigate} from "react-router-dom";
import {MostrarError} from "../../components/MostrarError";
import Strings from "../../assets/strings";
import {formatPeso, hasPermissionTo, PERSMISOS} from "../../helpers";
import {ButtonResponsive, Empty, ListViewMode, SeacrhAppBar, TableSort} from "../../components";
import {ReactComponent as EmptySvg} from "../../assets/img/wallet.svg";
import {Help} from "@mui/icons-material";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
const initialState={
    name: ''
};
function Carteras() {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const dispatch = useAppDispatch();
    const carteras = useAppSelector(state => state.carteras);

    const [filter, setFilter] = useState(initialState);

     useEffect(() => {
        dispatch(mostrarCarteras(undefined));
     }, [dispatch]);

    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        if(name === "name"){
            return mostrarCarteras({
                ...filter,
                [name]:value
            });
        }
        setFilter({...filter,[name]:value})
    };


     const { list, status, error } = carteras;
        const isEmpty = list?.length === 0;
      return (
          <>
              <AppBar/>
              <section className="contentInner">
                  <MostrarError errors={error}/>
                  {status === "loading" && <LoadingProgress vh/>}

                  <ListViewMode pageRows={list?.length} pageTotalRows={list?.length} noView>
                      <ButtonResponsive icon={<Help/>} text={Strings.ayuda} onClick={() => window.open("https://youtu.be/Tn2ZFByRZls","_blank")}/>
                      <SeacrhAppBar name="name" value={filter.name} onChange={handleFilter} />
                  </ListViewMode>
                  <TableSort data={[
                      {pro:"descripcion",text:Strings.descripcion},
                      {pro:"capital",text:Strings.capital},
                      {pro:"cantidadPrestamos",text:Strings.prestamos},
                      {pro:"carFechaCreacion",text:Strings.fecha}
                  ]} onSort={()=>{}} lessVh={144}>
                      <TableBody>
                          {list?.map(item =>
                              <TableRow key={item.id} onClick={()=>navigate(`/cartera/${item.id}`)}>

                                  <TableCell>{item.descripcion}</TableCell>
                                  <TableCell>{formatPeso(item.capital)}</TableCell>
                                  <TableCell>{item.cantidadPrestamos}</TableCell>
                                  <TableCell>--</TableCell>
                              </TableRow>
                          )}
                      </TableBody>
                  </TableSort>

                  {isEmpty &&
                      <Empty Img={EmptySvg} title={Strings.aunNoTienes+" "+Strings.carteras}>
                          <p>{Strings.carterasHelpMsj}</p>
                      </Empty>
                   }


                  {hasPermissionTo(PERSMISOS.carterasCrear) &&
                      <PlusFab component={Button} onClick={()=>navigate(pathname,{state:{id:""}})} />
                  }
                  <Crear/>

              </section>
          </>
        );

}

export default Carteras;
